import { BuildingModel, UserModel } from ".";
import { BuildingTypeModel } from "./buildingType.model";
import { DiagnosticModel } from "./diagnostic.model";
import { ObjectifModel } from "./objectif.model";

export class globalData
{
    /** Buildings */
    public buildings: Array<BuildingModel> = [];

    public get buildingsList(): Array<number>
    {
        return this.buildings.map(b=>{return b.id});
    }

    private _selectedBuildingsList: Array<number> = [];
    set selectedBuildingsList(s) {
        this._selectedBuildingsList = s;
        setTimeout(()=>{ this.selectionChange() }, 0);
    }
    get selectedBuildingsList() { return this._selectedBuildingsList; }

    public buildingChooserViewMode: string;

    //BuildingModel selected if only one
    public get uniqSelectedBuilding(): BuildingModel | null
    {
        if(this.hasUniqSelectedBuilding)
            return this.findBuildingById(this.selectedBuildingsList[0]);
        
        return null;
    }
    
    public get hasUniqSelectedBuilding():boolean
    {
        return (this.selectedBuildingsList.length==1);
    }

    public get selectedBuildings(): Array<BuildingModel>
    {
        return this.buildings.filter((building: BuildingModel) => {
            return this.selectedBuildingsList.includes(building.id);
        });;
    }

    public findBuildingById(id:number):BuildingModel | undefined
    {
        let find = this.buildings.filter((building:BuildingModel) => building.id==id);
        if(find.length==1) return find[0];
        return null;
    }

    /** BuildingTypes **/
    public buildingTypes: Array<BuildingTypeModel> = [];


    /** User **/
    public connectedUser: UserModel;
    public societyUsers: Array<UserModel>;

    /** Keep for navigation **/
    public current: any; //object to keep to avoid reloading
    public back: any; //object with navigation data to come back

    /** Config **/
    public headerTitle: string = null;
    public headerIcon: string = null;
    public showChooser: boolean = false;
    get truelyShowBuildingChooser()
    {
        return this.showChooser && this.buildings.length != 1;
    }
    headerBuilding: BuildingModel;

    toollist: object[];
    toolService: object;




    /*Observable*/
    observerList: selectionObserver[] = [];
    public subscribe(observer: selectionObserver)
    {
        if(!this.observerList.includes(observer))
            this.observerList.push(observer);
    }
    public unsubscribe(observer: selectionObserver)
    {
        const index = this.observerList.findIndex(o=>o==observer);
        this.observerList.splice(index, 1);
    }

    private selectionChange()
    {
        if(this.showChooser && this.hasUniqSelectedBuilding) {
            this.headerBuilding = this.uniqSelectedBuilding;
        }
        this.observerList.forEach(o=>{
            o.buildingsSelectionChanged();
        })
    }
}


export interface selectionObserver
{
    buildingsSelectionChanged();
}